import * as React from 'react';

import { cn } from '@/lib/utils';
import { controlDisabledClass, controlFocusClass, type ControlSize } from './control-styles';

const inputSizeClass: Record<ControlSize, string> = {
  sm: 'h-8 px-2.5',
  default: '',
  lg: 'h-10 px-4'
};

type InputProps = React.ComponentProps<'input'> & {
  /** Height and padding; omitted keeps the default 36px field. */
  controlSize?: ControlSize;
};

function Input({ className, type, controlSize, ...props }: InputProps) {
  if (type === 'range') {
    return (
      <input
        type="range"
        data-slot="input"
        data-type="range"
        className={cn(
          'accent-primary h-2 w-full min-w-0 cursor-pointer rounded-full outline-none',
          controlFocusClass,
          controlDisabledClass,
          className
        )}
        {...props}
      />
    );
  }
  return (
    <input
      type={type}
      data-slot="input"
      data-size={controlSize}
      className={cn(
        'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-[var(--state-disabled-opacity,0.5)] md:text-sm',
        'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[length:var(--focus-ring-width,3px)] focus-visible:ring-offset-[length:var(--focus-ring-offset,0px)]',
        'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
        controlSize ? inputSizeClass[controlSize] : undefined,
        className
      )}
      {...props}
    />
  );
}

export { Input };
export type { InputProps };
